import { render, staticRenderFns } from "./SuperTalkCommunity.vue?vue&type=template&id=2e6cf172&scoped=true"
import script from "./SuperTalkCommunity.vue?vue&type=script&lang=js"
export * from "./SuperTalkCommunity.vue?vue&type=script&lang=js"
import style0 from "./SuperTalkCommunity.vue?vue&type=style&index=0&id=2e6cf172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6cf172",
  null
  
)

export default component.exports